(function () {
  var root = document.querySelector('[data-magio-collection-search]');
  if (!root) return;

  var grid = root.querySelector('#product-grid');
  var countEl = root.querySelector('[data-magio-collection-count]');
  var pagination = root.querySelector('.magio-collection__pagination');
  var inputs = document.querySelectorAll('[data-magio-collection-search-input]');
  var toggles = document.querySelectorAll('[data-magio-open-collection-search]');
  var panel = document.querySelector('[data-magio-collection-search-panel]');
  var nav = document.querySelector('.magio-sticky-nav');
  if (!grid || !inputs.length) return;

  var originalHTML = grid.innerHTML;
  var originalCount = countEl ? countEl.textContent.trim() : '';
  var scope = root.getAttribute('data-search-scope') || 'collection';
  var collectionUrl = root.getAttribute('data-collection-url') || '';
  var moneyFormat = root.getAttribute('data-money-format') || 'Dhs. {{amount}}';
  var quickViewModal = root.getAttribute('data-quick-view-modal') || '';
  var catalogPromise = null;

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(price) {
    var amount = Number(price);
    if (!isFinite(amount)) return '';
    var fixed = amount.toFixed(2);
    var noDecimals = String(Math.round(amount));
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, fixed);
  }

  function cardHtml(product) {
    var variant = (product.variants && product.variants[0]) || {};
    var image = product.images && product.images[0];
    var src = image ? image.src : '';
    if (src) src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=800';
    var title = product.title || '';
    var href = '/products/' + product.handle;
    var price = formatMoney(variant.price);
    var compare = variant.compare_at_price ? Number(variant.compare_at_price) : 0;
    var current = Number(variant.price);
    var badge = '';
    if (compare > current && compare > 0) {
      var pct = Math.round(((compare - current) / compare) * 100);
      badge =
        '<div class="magio-product-card__badge-col" aria-hidden="true"><span class="magio-product-card__badge-inner"><span>Sale</span><span>' +
        pct +
        '%</span></span></div>';
    }
    var media = src
      ? '<img class="magio-product-card__image" alt="' +
        escapeHtml(title) +
        '" src="' +
        escapeHtml(src) +
        '&width=800" loading="lazy">'
      : '';
    var compareHtml =
      compare > current
        ? '<span class="magio-product-card__price--compare">' + escapeHtml(formatMoney(compare)) + '</span>'
        : '';
    return (
      '<li class="magio-collection__grid-item"><article class="magio-product-card"><a href="' +
      escapeHtml(href) +
      '" class="magio-product-card__link"><div class="magio-product-card__image-wrap"><div class="magio-product-card__image-clip">' +
      media +
      '</div>' +
      badge +
      '</div><div class="magio-product-card__meta"><p class="magio-product-card__title">' +
      escapeHtml(title) +
      '</p><div class="magio-product-card__details"><div class="magio-product-card__prices">' +
      compareHtml +
      '<span>' +
      escapeHtml(price) +
      '</span></div></div></div></a><div class="magio-product-card__quick-view"><button type="button" class="magio-product-card__quick-view-btn" data-magio-quick-view data-product-url="' +
      escapeHtml(href) +
      '" data-modal="' +
      escapeHtml(quickViewModal) +
      '" aria-haspopup="dialog"><span class="magio-product-card__quick-view-text">Quick view</span></button></div></article></li>'
    );
  }

  function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    catalogPromise = (async function () {
      var products = [];
      var page = 1;
      while (page <= 4) {
        var response = await fetch(collectionUrl + '/products.json?limit=250&page=' + page);
        if (!response.ok) break;
        var data = await response.json();
        var batch = data.products || [];
        products = products.concat(batch);
        if (batch.length < 250) break;
        page += 1;
      }
      return products;
    })();
    return catalogPromise;
  }

  function setCount(value) {
    if (countEl) countEl.textContent = String(value);
  }

  function setPaginationHidden(hidden) {
    if (pagination) pagination.hidden = hidden;
  }

  function filterDom(query) {
    var items = grid.querySelectorAll('.magio-collection__grid-item');
    var shown = 0;
    items.forEach(function (item) {
      var title = item.querySelector('.magio-product-card__title');
      var text = (title ? title.textContent : item.textContent).toLowerCase();
      var match = !query || text.indexOf(query) !== -1;
      item.hidden = !match;
      if (match) shown += 1;
    });
    return shown;
  }

  function showEmpty(query) {
    grid.innerHTML =
      '<li class="magio-collection__grid-item magio-collection__search-empty">No products match “' +
      escapeHtml(query) +
      '”.</li>';
    setCount(0);
  }

  function restore() {
    grid.innerHTML = originalHTML;
    setCount(originalCount);
    setPaginationHidden(false);
    inputs.forEach(function (input) {
      if (input.value) input.value = '';
    });
  }

  async function applyQuery(query) {
    var normalized = query.trim().toLowerCase();
    if (!normalized) {
      restore();
      return;
    }

    setPaginationHidden(true);

    if (scope === 'brand') {
      grid.innerHTML = originalHTML;
      var shown = filterDom(normalized);
      setCount(shown);
      if (!shown) showEmpty(query.trim());
      return;
    }

    try {
      var products = await loadCatalog();
      var matches = products.filter(function (product) {
        var haystack = (product.title + ' ' + (product.vendor || '') + ' ' + (product.product_type || '')).toLowerCase();
        return haystack.indexOf(normalized) !== -1;
      });
      if (!matches.length) {
        showEmpty(query.trim());
        return;
      }
      grid.innerHTML = matches.map(cardHtml).join('');
      setCount(matches.length);
    } catch (error) {
      var fallbackShown = filterDom(normalized);
      setCount(fallbackShown);
      if (!fallbackShown) showEmpty(query.trim());
    }
  }

  var timer = 0;
  function onInput(event) {
    var value = event.target.value;
    inputs.forEach(function (input) {
      if (input !== event.target) input.value = value;
    });
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      applyQuery(value);
    }, 180);
  }

  inputs.forEach(function (input) {
    input.addEventListener('input', onInput);
    input.addEventListener('search', onInput);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') event.preventDefault();
    });
  });

  function setOpen(open) {
    if (panel) panel.hidden = !open;
    if (nav) nav.classList.toggle('is-search-open', open);
    toggles.forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (open) {
      var desktopInput = panel ? panel.querySelector('[data-magio-collection-search-input]') : inputs[0];
      if (desktopInput) desktopInput.focus();
    }
  }

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var open = panel ? panel.hidden : false;
      setOpen(open);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && panel && !panel.hidden) setOpen(false);
  });

  document.addEventListener('pointerdown', function (event) {
    if (!panel || panel.hidden) return;
    var target = event.target;
    if (panel.contains(target)) return;
    if (target.closest && target.closest('[data-magio-open-collection-search]')) return;
    if (target.closest && target.closest('[data-magio-collection-search-input]')) return;
    setOpen(false);
  });
})();
